import { CLAUDI_STICKERS, type ClaudiStickerDef, type ClaudiStickerId } from '../../../domain';
import { claudiStickerIconSrc } from '../../stickers/claudiStickerIcons';

export type StickerRewardScreenProps = {
  stickerId: ClaudiStickerId;
  onClaim?: () => void;
};

export type StickerRewardScreenModel = {
  sticker: ClaudiStickerDef;
  stickerIconSrc: string;
  onClaim?: () => void;
};

export function createStickerRewardScreenModel(
  props: StickerRewardScreenProps,
): StickerRewardScreenModel {
  const sticker =
    CLAUDI_STICKERS.find((def) => def.id === props.stickerId) ??
    CLAUDI_STICKERS[0];

  return {
    sticker,
    stickerIconSrc: claudiStickerIconSrc(sticker.id),
    onClaim: props.onClaim,
  };
}
